var x;!function(x){x.XXS="xxs"}(x||(x={}));export{x as ChipsSize};
